export const profissionais = [
  {
    id: 1,
    profissional: "Luiz Persechini",
    icone: "sys",
    oQueFaz: "Diretor",
    trabalho:
      "Lidera a visão estratégica da tecnologia, conectando inovação, negócio e pessoas para impulsionar o crescimento e a transformação da empresa."
  },
  {
    id: 2,
    profissional: "Luciano Cardoso",
    icone: "sys",
    oQueFaz: "Gerente Geral",
    trabalho:
      "Lidera a área de TI, conectando equipes, projetos e estratégias para transformar as necessidades do negócio em soluções que geram resultados."
  },
  {
    id: 3,
    profissional: "Gutemberg Reboucas",
    icone: "sys",
    oQueFaz: "Coordenação de TI",
    trabalho:
      "Nosso coordenador. Conecta pessoas, projetos e estratégias para garantir que a tecnologia gere valor para toda a empresa."
  },
  {
    id: 4,
    profissional: "Luis Belchior",
    icone: "BD",
    oQueFaz: "Especialista Datasul",
    trabalho:
      "Nosso especialista Datasul. Referência quando o assunto é ERP, integrações e suporte aos processos que movimentam a operação da empresa."
  },
  {
    id: 5,
    profissional: "Rodrigo Santana",
    icone: "sys",
    oQueFaz: "Comunicação via Rádio",
    trabalho:
      "Especialista em rádio e comunicação operacional. Responsável por manter equipes conectadas mesmo nos ambientes mais desafiadores."
  },
  {
    id: 6,
    profissional: "Thiago Cedro",
    icone: "code",
    oQueFaz: "Sistemas, Automação e BI",
    trabalho:
      "Especialista em evoluir soluções. Trabalha na melhoria contínua dos sistemas da Solve, desenvolvimento de indicadores em BI e otimização de processos internos."
  },
  {
    id: 7,
    profissional: "Ricamar Santana",
    icone: "code",
    oQueFaz: "Desenvolvimento Interno",
    trabalho:
      "Desenvolvedor de soluções internas que ajudam a empresa a trabalhar de forma mais simples, rápida e eficiente."
  },
  {
    id: 8,
    profissional: "Matheus Lima",
    icone: "code",
    oQueFaz: "Desenvolvimento Interno",
    trabalho:
      "Transforma necessidades do negócio em sistemas e ferramentas que facilitam o dia a dia de todos."
  },
  {
    id: 9,
    profissional: "Pedro Martins",
    icone: "infra",
    oQueFaz: "Infraestrutura e Cibersegurança",
    trabalho:
      "Guardião da infraestrutura e da segurança digital. Mantém servidores, redes, equipamentos e ambientes protegidos para que tudo funcione sem interrupções."
  },
  {
    id: 10,
    profissional: "Kelly Mendes",
    icone: "code",
    oQueFaz: "Desenvolvimento, Automação e BI",
    trabalho:
      "Atua no desenvolvimento de indicadores, automação de processos, suporte aos sistemas da Solve e criação de dashboards que transformam dados em decisões."
  },
  {
    id: 11,
    profissional: "Alaor Ribeiro",
    icone: "infra",
    oQueFaz: "Infraestrutura e Cibersegurança",
    trabalho:
      "Especialista em infraestrutura e cibersegurança, focado em manter os ambientes tecnológicos seguros, estáveis e sempre disponíveis."
  },
  {
    id: 12,
    profissional: "Alexsandro Oliveira",
    icone: "infra",
    oQueFaz: "Infraestrutura e Cibersegurança",
    trabalho:
      "Responsável por fortalecer a infraestrutura e a proteção dos ambientes tecnológicos utilizados diariamente pela empresa."
  },
  {
    id: 13,
    profissional: "Enzo Francisco",
    icone: "infra",
    oQueFaz: "Infraestrutura e Cibersegurança",
    trabalho:
      "Atua na sustentação dos ambientes de TI, contribuindo para a infraestrutura, segurança e continuidade dos serviços."
  },
  {
    id: 14,
    profissional: "Julia Vidal",
    icone: "sys",
    oQueFaz: "Administração e Compras de TI",
    trabalho:
      "Cuida dos bastidores da TI. Responsável por orçamento, compras, contratos, estoque e pelo suporte administrativo que mantém a área em movimento."
  },
  {
    id: 15,
    profissional: "Vincci Carmides",
    icone: "sys",
    oQueFaz: "Administração e Compras de TI",
    trabalho:
      "Especialista na gestão administrativa da TI, garantindo o controle de recursos, aquisições e organização dos ativos da área."
  },
  {
    id: 16,
    profissional: "Maria Eduarda",
    icone: "infra",
    oQueFaz: "Infraestrutura e Cibersegurança",
    trabalho:
      "Ajuda a garantir a estabilidade do ambiente tecnológico, atuando em infraestrutura, suporte e cibersegurança para manter a operação protegida."
  }
];